import React, { useEffect, useContext } from "react";
import { Alert } from "antd";
import FormLegalVacationDays from "./FormLegalVacationDays";
import LegalVacationDaysContext from "../../context/legalvacationdays/legalvacationdaysContext"
import AdditionalDaysContext from "../../context/additionaldays/additionaldaysContext";
import AlertContext from "../../context/alert/alertContext";
import AdministrativelDaysContext from "../../context/administrativedays/administrativedaysContext";

const LegalVacationDays = () => {
  const legalvacationdaysContext = useContext(LegalVacationDaysContext);
  const alertContext = useContext(AlertContext);
  const additionalDaysContext = useContext(AdditionalDaysContext);
  const administrativelDaysContext = useContext(AdministrativelDaysContext);
  const { alert, showAlert } = alertContext;

  const {
    getTypes,
    additional,
    loading,
    message,
    types,
    balanceDays,
    getBalanceDays,
    legalvacationRequestPending,
    getLegalVacationRequestsByCodEmployee,
    addLegalVacationRequest
  } = legalvacationdaysContext;

  const {
    holidays,
    getHolidays,
  } = administrativelDaysContext;

  useEffect(() => {
    function fetchData() {
      const user = JSON.parse(localStorage.getItem("user"));
      getBalanceDays(user.username);
      getLegalVacationRequestsByCodEmployee(user.username);
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchGetHolidays() {
      getHolidays();
    }
    fetchGetHolidays();
  }, []);

  return (
    <>     
    { legalvacationRequestPending.length === 0 ? (
        <FormLegalVacationDays
          balanceDays={balanceDays} 
          legalvacationRequestPending={legalvacationRequestPending} 
          addLegalVacationRequest={addLegalVacationRequest}
          loading={loading}
          message={message}
          alert={alert}
          showAlert={showAlert}          
          holidays={holidays}
        />    
        ) : (
          <Alert
            message="Solicitud pendiente"
            description="Usted tiene una solicitud pendiente, favor contactar a supervisor."
            type="info"
            showIcon
            style={{ width: "50%" }}
          />
      )} 
    </>
  );
};

export default LegalVacationDays;
